import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { Box, Fade, Grid, IconButton } from "@mui/material";

import useWindowDimensions from "../utils/useWindowDimensions";
import RandomImage from "./RandomImage";
import RandomPoseControls from "./RandomPoseControls";

import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export default function Overlay({
  open,
  image,
  timeLimit,
  refreshImg,
  closeHandler,
  sessionType,
  theme,
  darkMode,
}) {

  const [timer, updateTimer] = useState(false);
  const [timerPlaying, setTimerPlaying] = useState(false);
  const [pauseClicked, setPauseClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const isThereAnImage = typeof image === "undefined" ? false : true;
  const { height, width } = useWindowDimensions();
  const isLandscape = parseInt(height) > parseInt(width) ? false : true;


  React.useEffect(() => {
    if (!isThereAnImage) setTimeout(resetStuff, 3000);
    else {
      // initializing values
      setPauseClicked(false);
      // setIsLoading(true);
      // setTimerPlaying(false);
      // setFadeClass("fade-out");
    }
  }, [image, isThereAnImage]);

  const togglePauseSession = () => {
    setTimerPlaying(!timerPlaying);
    setPauseClicked(!pauseClicked);
  };

  const actualRefreshImg = () => {
    setIsLoading(true);
    setTimerPlaying(false);
    updateTimer(!timer);
    setTimeout(() => {
      refreshImg();
    }, 3500); // was 500
    // setFadeClass("fade-out");
  };

  const imageLoaded = () => {
    // setFadeClass("fade-in");
    setTimerPlaying(true);
    // setTimeout(() => {
      setIsLoading(false);
    // }, 100);
  };

  const resetStuff = () => {
    setTimerPlaying(false);
    setIsLoading(true);
    closeHandler();
  }

  return (
    <Modal
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      open={open}
      onClose={closeHandler}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
        style: { backgroundColor: "transparent" },
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: darkMode
              ? "rgba(0,0,0, 0.9)"
              : "rgba(255,255,255, 0.9)",
          }}
        >
          <Grid container style={{ height: "100%" }}>
          
            <IconButton onClick={closeHandler}  style={{'position' : 'absolute', 'top': 10, 'right': 10}}>
              <HighlightOffIcon style={{'fontSize': 32}}/>
            </IconButton>
            <Grid item xs={isLandscape ? 2 : 12}></Grid>
            <Grid
              item
              container
              xs={isLandscape ? 8 : 12}
              justifyContent="center"
              alignItems="center"
              className="image-container"
            >
              <RandomImage
                imageLoaded={imageLoaded}
                image={image}
                isThereAnImage={isThereAnImage}
                isLoading={isLoading}
              />
            </Grid>
            <Grid
              item
              container
              xs={isLandscape ? 2 : 12}
              direction="column"
              alignItems="center"
            >
              <RandomPoseControls
                theme={theme}
                isLoading={isLoading}
                isLandscape={isLandscape}
                togglePauseSession={togglePauseSession}
                pauseClicked={pauseClicked}
                actualRefreshImg={actualRefreshImg}
                timeLimit={timeLimit}
                timerPlaying={timerPlaying}
                timer={timer}
                sessionType={sessionType}
                isThereAnImage={isThereAnImage}
                closeHandler={resetStuff}
              />
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
}
